//saga imports
import { takeEvery, put, call, all, fork } from "redux-saga/effects";

import {
  SEED_APPROVED_STAFF_LEAVE,
  STAFF_HOLIDAY_CALENDAR_LIST,
  STAFF_HOLIDAY_CALENDAR_DATA,
  STAFF_HOLIDAY_CALENDAR_CREATE,
  STAFF_HOLIDAY_CALENDAR_UPDATE,
  STAFF_HOLIDAY_CALENDAR_DELETE,
  STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS,
  STAFF_HOLIDAY_CALENDAR_PERIOD_LIST,
  STAFF_HOLIDAY_CALENDAR_PERIOD_DATA,
  STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE,
  STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE,
  STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE,
  CALENDAR_NON_WORKING_DAY_LIST,
  CALENDAR_NON_WORKING_DAY_DATA,
  CALENDAR_NON_WORKING_DAY_CREATE,
  CALENDAR_NON_WORKING_DAY_UPDATE,
  CALENDAR_NON_WORKING_DAY_DELETE,
  STAFF_LEAVE_CREATE_REQUEST,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST,
  STAFF_LEAVE_DECISION_APPROVE,
  STAFF_LEAVE_DECISION_DECLINE,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY,
  STAFF_LEAVE_DECISION_DATA,
  STAFF_LEAVE_DECISION_LIST_MY_OPEN,
  STAFF_LEAVE_DECISION_LIST,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH,
  STAFF_LEAVE_RESTRICTION_PERIOD_LIST,
  STAFF_LEAVE_RESTRICTION_PERIOD_DATA,
  STAFF_LEAVE_RESTRICTION_PERIOD_CREATE,
  STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE,
  STAFF_LEAVE_RESTRICTION_PERIOD_DELETE,
} from "./actionType";

import {
  staffHolidayCalendarListSuccess,
  staffHolidayCalendarListFail,
  staffHolidayCalendarpayloadSuccess,
  staffHolidayCalendarpayloadFail,
  staffHolidayCalendarCreateSuccess,
  staffHolidayCalendarCreateFail,
  staffHolidayCalendarUpdateSuccess,
  staffHolidayCalendarUpdateFail,
  staffHolidayCalendarDeleteSuccess,
  staffHolidayCalendarDeleteFail,
  staffHolidayCalendarGeneratePeriodsSuccess,
  staffHolidayCalendarGeneratePeriodsFail,
  staffHolidayCalendarPeriodListSuccess,
  staffHolidayCalendarPeriodListFail,
  staffHolidayCalendarPeriodDataSuccess,
  staffHolidayCalendarPeriodDataFail,
  staffHolidayCalendarPeriodCreateSuccess,
  staffHolidayCalendarPeriodCreateFail,
  staffHolidayCalendarPeriodUpdateSuccess,
  staffHolidayCalendarPeriodUpdateFail,
  staffHolidayCalendarPeriodDeleteSuccess,
  staffHolidayCalendarPeriodDeleteFail,
  calendarNonWorkingDayListSuccess,
  calendarNonWorkingDayListFail,
  calendarNonWorkingDayDataSuccess,
  calendarNonWorkingDayDataFail,
  calendarNonWorkingDayCreateSuccess,
  calendarNonWorkingDayCreateFail,
  calendarNonWorkingDayUpdateSuccess,
  calendarNonWorkingDayUpdateFail,
  calendarNonWorkingDayDeleteSuccess,
  calendarNonWorkingDayDeleteFail,
  createStaffLeaveRequestSuccess,
  createStaffLeaveRequestFail,
  staffToStaffHolidayCalendarPeriodListCurrentSuccess,
  staffToStaffHolidayCalendarPeriodListCurrentFail,
  staffToStaffHolidayCalendarPeriodListFutureSuccess,
  staffToStaffHolidayCalendarPeriodListFutureFail,
  staffToStaffHolidayCalendarPeriodListPastSuccess,
  staffToStaffHolidayCalendarPeriodListPastFail,
  staffToStaffHolidayCalendarPeriodListSuccess,
  staffToStaffHolidayCalendarPeriodListFail,
  staffLeaveDecisionApproveSuccess,
  staffLeaveDecisionApproveFail,
  staffLeaveDecisionDeclineSuccess,
  staffLeaveDecisionDeclineFail,
  staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembersSuccess,
  staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembersFail,
  staffToStaffHolidayCalendarPeriodListCurrentMySuccess,
  staffToStaffHolidayCalendarPeriodListCurrentMyFail,
  staffLeaveDecisionDataSuccess,
  staffLeaveDecisionDataFail,
  staffLeaveDecisionListMyOpenSuccess,
  staffLeaveDecisionListMyOpenFail,
  staffLeaveDecisionListSuccess,
  staffLeaveDecisionListFail,
  overviewStaffToStaffHolidayCalendarPeriodListCurrentSuccess,
  overviewStaffToStaffHolidayCalendarPeriodListCurrentFail,
  overviewStaffToStaffHolidayCalendarPeriodListFutureSuccess,
  overviewStaffToStaffHolidayCalendarPeriodListFutureFail,
  overviewStaffToStaffHolidayCalendarPeriodListPastSuccess,
  overviewStaffToStaffHolidayCalendarPeriodListPastFail,
  overviewStaffToStaffHolidayCalendarPeriodListSuccess,
  overviewStaffToStaffHolidayCalendarPeriodListFail,
  staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembersSuccess,
  staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembersFail,
  staffToStaffHolidayCalendarPeriodSearchSuccess,
  staffToStaffHolidayCalendarPeriodSearchFail,
  staffLeaveRestrictionPeriodListSuccess,
  staffLeaveRestrictionPeriodListFail,
  staffLeaveRestrictionPeriodDataSuccess,
  staffLeaveRestrictionPeriodDataFail,
  staffLeaveRestrictionPeriodCreateSuccess,
  staffLeaveRestrictionPeriodCreateFail,
  staffLeaveRestrictionPeriodUpdateSuccess,
  staffLeaveRestrictionPeriodUpdateFail,
  seedApprovedStaffLeaveSuccess,
  seedApprovedStaffLeaveFail,
  staffLeaveRestrictionPeriodDeleteSuccess,
  staffLeaveRestrictionPeriodDeleteFail,
} from "./action";

/// api
import {
  getStaffHolidayCalendarListApi,
  getStaffHolidayCalendarDataApi,
  createStaffHolidayCalendarApi,
  updateStaffHolidayCalendarApi,
  deleteStaffHolidayCalendarApi,
  generateStaffHolidayCalendarPeriodsApi,
  getStaffHolidayCalendarPeriodListApi,
  getStaffHolidayCalendarPeriodDataApi,
  createStaffHolidayCalendarPeriodApi,
  updateStaffHolidayCalendarPeriodApi,
  deleteStaffHolidayCalendarPeriodApi,
  getCalendarNonWorkingDayListApi,
  getCalendarNonWorkingDayDataApi,
  createCalendarNonWorkingDayApi,
  updateCalendarNonWorkingDayApi,
  deleteCalendarNonWorkingDayApi,
  createStaffLeaveRequestApi,
  getstaffToStaffHolidayCalendarPeriodListCurrentApi,
  getstaffToStaffHolidayCalendarPeriodListFutureApi,
  getstaffToStaffHolidayCalendarPeriodListPastApi,
  getstaffToStaffHolidayCalendarPeriodListApi,
  staffLeaveDecisionApproveApi,
  staffLeaveDecisionDeclineApi,
  staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembersApi,
  staffToStaffHolidayCalendarPeriodListCurrentMyApi,
  staffLeaveDecisionDataApi,
  staffLeaveDecisionListMyOpenApi,
  staffLeaveDecisionListApi,
  overviewStaffToStaffHolidayCalendarPeriodListCurrentApi,
  overviewStaffToStaffHolidayCalendarPeriodListFutureApi,
  overviewStaffToStaffHolidayCalendarPeriodListPastApi,
  overviewStaffToStaffHolidayCalendarPeriodListApi,
  staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembersApi,
  staffToStaffHolidayCalendarPeriodSearchApi,
  getStaffLeaveRestrictionPeriodListApi,
  getStaffLeaveRestrictionPeriodDataApi,
  seedApprovedStaffLeaveApi,
  createStaffLeaveRestrictionPeriodApi,
  updateStaffLeaveRestrictionPeriodApi,
  deleteStaffLeaveRestrictionPeriodApi,
} from "../../helpers/fakebackend_helper";

//staffHolidayCalendarList
function* staffHolidayCalendarList() {
  try {
    const response = yield call(getStaffHolidayCalendarListApi);
    yield put(staffHolidayCalendarListSuccess(response));
  } catch (error) {
    yield put(staffHolidayCalendarListFail(error));
  }
}

export function* watchStaffHolidayCalendarList() {
  yield takeEvery(STAFF_HOLIDAY_CALENDAR_LIST, staffHolidayCalendarList);
}

//staffHolidayCalendarData
function* staffHolidayCalendarData({ payload }) {
  try {
    const response = yield call(getStaffHolidayCalendarDataApi, payload);
    yield put(staffHolidayCalendarpayloadSuccess(response));
  } catch (error) {
    yield put(staffHolidayCalendarpayloadFail(error));
  }
}

export function* watchStaffHolidayCalendarData() {
  yield takeEvery(STAFF_HOLIDAY_CALENDAR_DATA, staffHolidayCalendarData);
}

//staffHolidayCalendarCreate
function* staffHolidayCalendarCreate({ payload }) {
  try {
    const response = yield call(createStaffHolidayCalendarApi, payload);
    yield put(staffHolidayCalendarCreateSuccess(response));
  } catch (error) {
    yield put(staffHolidayCalendarCreateFail(error));
  }
}

export function* watchStaffHolidayCalendarCreate() {
  yield takeEvery(STAFF_HOLIDAY_CALENDAR_CREATE, staffHolidayCalendarCreate);
}

//staffHolidayCalendarUpdate
function* staffHolidayCalendarUpdate({ payload }) {
  try {
    const response = yield call(updateStaffHolidayCalendarApi, payload);
    yield put(staffHolidayCalendarUpdateSuccess(response));
  } catch (error) {
    yield put(staffHolidayCalendarUpdateFail(error));
  }
}

export function* watchStaffHolidayCalendarUpdate() {
  yield takeEvery(STAFF_HOLIDAY_CALENDAR_UPDATE, staffHolidayCalendarUpdate);
}

//staffHolidayCalendarDelete
function* staffHolidayCalendarDelete({ payload }) {
  try {
    const response = yield call(deleteStaffHolidayCalendarApi, payload);
    yield put(staffHolidayCalendarDeleteSuccess(response));
  } catch (error) {
    yield put(staffHolidayCalendarDeleteFail(error));
  }
}

export function* watchStaffHolidayCalendarDelete() {
  yield takeEvery(STAFF_HOLIDAY_CALENDAR_DELETE, staffHolidayCalendarDelete);
}

//staffHolidayCalendarGeneratePeriods
function* staffHolidayCalendarGeneratePeriods() {
  try {
    const response = yield call(generateStaffHolidayCalendarPeriodsApi);
    yield put(staffHolidayCalendarGeneratePeriodsSuccess(response));
  } catch (error) {
    yield put(staffHolidayCalendarGeneratePeriodsFail(error));
  }
}

export function* watchStaffHolidayCalendarGeneratePeriods() {
  yield takeEvery(
    STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS,
    staffHolidayCalendarGeneratePeriods
  );
}

//staffHolidayCalendarPeriodList
function* staffHolidayCalendarPeriodList() {
  try {
    const response = yield call(getStaffHolidayCalendarPeriodListApi);
    yield put(staffHolidayCalendarPeriodListSuccess(response));
  } catch (error) {
    yield put(staffHolidayCalendarPeriodListFail(error));
  }
}

export function* watchStaffHolidayCalendarPeriodList() {
  yield takeEvery(
    STAFF_HOLIDAY_CALENDAR_PERIOD_LIST,
    staffHolidayCalendarPeriodList
  );
}

//staffHolidayCalendarPeriodData
function* staffHolidayCalendarPeriodData({ payload }) {
  try {
    const response = yield call(getStaffHolidayCalendarPeriodDataApi, payload);
    yield put(staffHolidayCalendarPeriodDataSuccess(response));
  } catch (error) {
    yield put(staffHolidayCalendarPeriodDataFail(error));
  }
}

export function* watchStaffHolidayCalendarPeriodData() {
  yield takeEvery(
    STAFF_HOLIDAY_CALENDAR_PERIOD_DATA,
    staffHolidayCalendarPeriodData
  );
}

//staffHolidayCalendarPeriodCreate
function* staffHolidayCalendarPeriodCreate({ payload }) {
  try {
    const response = yield call(createStaffHolidayCalendarPeriodApi, payload);
    yield put(staffHolidayCalendarPeriodCreateSuccess(response));
  } catch (error) {
    yield put(staffHolidayCalendarPeriodCreateFail(error));
  }
}

export function* watchStaffHolidayCalendarPeriodCreate() {
  yield takeEvery(
    STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE,
    staffHolidayCalendarPeriodCreate
  );
}

//staffHolidayCalendarPeriodUpdate
function* staffHolidayCalendarPeriodUpdate({ payload }) {
  try {
    const response = yield call(updateStaffHolidayCalendarPeriodApi, payload);
    yield put(staffHolidayCalendarPeriodUpdateSuccess(response));
  } catch (error) {
    yield put(staffHolidayCalendarPeriodUpdateFail(error));
  }
}

export function* watchStaffHolidayCalendarPeriodUpdate() {
  yield takeEvery(
    STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE,
    staffHolidayCalendarPeriodUpdate
  );
}

//staffHolidayCalendarPeriodDelete
function* staffHolidayCalendarPeriodDelete({ payload }) {
  try {
    const response = yield call(deleteStaffHolidayCalendarPeriodApi, payload);
    yield put(staffHolidayCalendarPeriodDeleteSuccess(response));
  } catch (error) {
    yield put(staffHolidayCalendarPeriodDeleteFail(error));
  }
}

export function* watchStaffHolidayCalendarPeriodDelete() {
  yield takeEvery(
    STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE,
    staffHolidayCalendarPeriodDelete
  );
}

//calendarNonWorkingDayList
function* calendarNonWorkingDayList() {
  try {
    const response = yield call(getCalendarNonWorkingDayListApi);
    yield put(calendarNonWorkingDayListSuccess(response));
  } catch (error) {
    yield put(calendarNonWorkingDayListFail(error));
  }
}

export function* watchCalendarNonWorkingDayList() {
  yield takeEvery(CALENDAR_NON_WORKING_DAY_LIST, calendarNonWorkingDayList);
}

//calendarNonWorkingDayData
function* calendarNonWorkingDayData({ payload }) {
  try {
    const response = yield call(getCalendarNonWorkingDayDataApi, payload);
    yield put(calendarNonWorkingDayDataSuccess(response));
  } catch (error) {
    yield put(calendarNonWorkingDayDataFail(error));
  }
}

export function* watchCalendarNonWorkingDayData() {
  yield takeEvery(CALENDAR_NON_WORKING_DAY_DATA, calendarNonWorkingDayData);
}

//calendarNonWorkingDayCreate
function* calendarNonWorkingDayCreate({ payload }) {
  try {
    const response = yield call(createCalendarNonWorkingDayApi, payload);
    yield put(calendarNonWorkingDayCreateSuccess(response));
  } catch (error) {
    yield put(calendarNonWorkingDayCreateFail(error));
  }
}

export function* watchCalendarNonWorkingDayCreate() {
  yield takeEvery(CALENDAR_NON_WORKING_DAY_CREATE, calendarNonWorkingDayCreate);
}

//calendarNonWorkingDayUpdate
function* calendarNonWorkingDayUpdate({ payload }) {
  try {
    const response = yield call(updateCalendarNonWorkingDayApi, payload);
    yield put(calendarNonWorkingDayUpdateSuccess(response));
  } catch (error) {
    yield put(calendarNonWorkingDayUpdateFail(error));
  }
}

export function* watchCalendarNonWorkingDayUpdate() {
  yield takeEvery(CALENDAR_NON_WORKING_DAY_UPDATE, calendarNonWorkingDayUpdate);
}

//calendarNonWorkingDayDelete
function* calendarNonWorkingDayDelete({ payload }) {
  try {
    const response = yield call(deleteCalendarNonWorkingDayApi, payload);
    yield put(calendarNonWorkingDayDeleteSuccess(response));
  } catch (error) {
    yield put(calendarNonWorkingDayDeleteFail(error));
  }
}

export function* watchCalendarNonWorkingDayDelete() {
  yield takeEvery(CALENDAR_NON_WORKING_DAY_DELETE, calendarNonWorkingDayDelete);
}

//createStaffLeaveRequest
function* createStaffLeaveRequest({ payload }) {
  try {
    const response = yield call(createStaffLeaveRequestApi, payload);
    yield put(createStaffLeaveRequestSuccess(response));
  } catch (error) {
    yield put(createStaffLeaveRequestFail(error));
  }
}

export function* watchCreateStaffLeaveRequest() {
  yield takeEvery(STAFF_LEAVE_CREATE_REQUEST, createStaffLeaveRequest);
}

//staffToStaffHolidayCalendarPeriodListCurrent
function* staffToStaffHolidayCalendarPeriodListCurrent() {
  try {
    const response = yield call(
      getstaffToStaffHolidayCalendarPeriodListCurrentApi
    );
    yield put(staffToStaffHolidayCalendarPeriodListCurrentSuccess(response));
  } catch (error) {
    yield put(staffToStaffHolidayCalendarPeriodListCurrentFail(error));
  }
}

export function* watchStaffToStaffHolidayCalendarPeriodListCurrent() {
  yield takeEvery(
    STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT,
    staffToStaffHolidayCalendarPeriodListCurrent
  );
}

//staffToStaffHolidayCalendarPeriodListFuture
function* staffToStaffHolidayCalendarPeriodListFuture() {
  try {
    const response = yield call(
      getstaffToStaffHolidayCalendarPeriodListFutureApi
    );
    yield put(staffToStaffHolidayCalendarPeriodListFutureSuccess(response));
  } catch (error) {
    yield put(staffToStaffHolidayCalendarPeriodListFutureFail(error));
  }
}

export function* watchStaffToStaffHolidayCalendarPeriodListFuture() {
  yield takeEvery(
    STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE,
    staffToStaffHolidayCalendarPeriodListFuture
  );
}

//staffToStaffHolidayCalendarPeriodListPast
function* staffToStaffHolidayCalendarPeriodListPast() {
  try {
    const response = yield call(
      getstaffToStaffHolidayCalendarPeriodListPastApi
    );
    yield put(staffToStaffHolidayCalendarPeriodListPastSuccess(response));
  } catch (error) {
    yield put(staffToStaffHolidayCalendarPeriodListPastFail(error));
  }
}

export function* watchStaffToStaffHolidayCalendarPeriodListPast() {
  yield takeEvery(
    STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST,
    staffToStaffHolidayCalendarPeriodListPast
  );
}

//staffToStaffHolidayCalendarPeriodList
function* staffToStaffHolidayCalendarPeriodList() {
  try {
    const response = yield call(getstaffToStaffHolidayCalendarPeriodListApi);
    yield put(staffToStaffHolidayCalendarPeriodListSuccess(response));
  } catch (error) {
    yield put(staffToStaffHolidayCalendarPeriodListFail(error));
  }
}

export function* watchStaffToStaffHolidayCalendarPeriodList() {
  yield takeEvery(
    STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST,
    staffToStaffHolidayCalendarPeriodList
  );
}

//staffLeaveDecisionApprove
function* staffLeaveDecisionApprove({ payload, token }) {
  try {
    const response = yield call(staffLeaveDecisionApproveApi, payload, token);
    yield put(staffLeaveDecisionApproveSuccess(response));
  } catch (error) {
    yield put(staffLeaveDecisionApproveFail(error));
  }
}

export function* watchStaffLeaveDecisionApprove() {
  yield takeEvery(STAFF_LEAVE_DECISION_APPROVE, staffLeaveDecisionApprove);
}

//staffLeaveDecisionDecline
function* staffLeaveDecisionDecline({ payload, token }) {
  try {
    const response = yield call(staffLeaveDecisionDeclineApi, payload, token);
    yield put(staffLeaveDecisionDeclineSuccess(response));
  } catch (error) {
    yield put(staffLeaveDecisionDeclineFail(error));
  }
}

export function* watchStaffLeaveDecisionDecline() {
  yield takeEvery(STAFF_LEAVE_DECISION_DECLINE, staffLeaveDecisionDecline);
}

//staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembers
function* staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembers() {
  try {
    const response = yield call(
      staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembersApi
    );
    yield put(
      staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembersSuccess(response)
    );
  } catch (error) {
    yield put(
      staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembersFail(error)
    );
  }
}

export function* watchStaffToStaffHolidayCalendarPeriodListCurrentMyTeamMembers() {
  yield takeEvery(
    STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS,
    staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembers
  );
}

//staffToStaffHolidayCalendarPeriodListCurrentMy
function* staffToStaffHolidayCalendarPeriodListCurrentMy() {
  try {
    const response = yield call(
      staffToStaffHolidayCalendarPeriodListCurrentMyApi
    );
    yield put(staffToStaffHolidayCalendarPeriodListCurrentMySuccess(response));
  } catch (error) {
    yield put(staffToStaffHolidayCalendarPeriodListCurrentMyFail(error));
  }
}

export function* watchStaffToStaffHolidayCalendarPeriodListCurrentMy() {
  yield takeEvery(
    STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY,
    staffToStaffHolidayCalendarPeriodListCurrentMy
  );
}

//staffLeaveDecisionData
function* staffLeaveDecisionData({ payload, token }) {
  try {
    const response = yield call(staffLeaveDecisionDataApi, payload, token);
    yield put(staffLeaveDecisionDataSuccess(response));
  } catch (error) {
    yield put(staffLeaveDecisionDataFail(error));
  }
}

export function* watchStaffLeaveDecisionData() {
  yield takeEvery(STAFF_LEAVE_DECISION_DATA, staffLeaveDecisionData);
}

//staffLeaveDecisionListMyOpen
function* staffLeaveDecisionListMyOpen() {
  try {
    const response = yield call(staffLeaveDecisionListMyOpenApi);
    yield put(staffLeaveDecisionListMyOpenSuccess(response));
  } catch (error) {
    yield put(staffLeaveDecisionListMyOpenFail(error));
  }
}

export function* watchStaffLeaveDecisionListMyOpen() {
  yield takeEvery(
    STAFF_LEAVE_DECISION_LIST_MY_OPEN,
    staffLeaveDecisionListMyOpen
  );
}

//staffLeaveDecisionList
function* staffLeaveDecisionList() {
  try {
    const response = yield call(staffLeaveDecisionListApi);
    yield put(staffLeaveDecisionListSuccess(response));
  } catch (error) {
    yield put(staffLeaveDecisionListFail(error));
  }
}

export function* watchStaffLeaveDecisionList() {
  yield takeEvery(STAFF_LEAVE_DECISION_LIST, staffLeaveDecisionList);
}

//overviewStaffToStaffHolidayCalendarPeriodListCurrent
function* overviewStaffToStaffHolidayCalendarPeriodListCurrent() {
  try {
    const response = yield call(
      overviewStaffToStaffHolidayCalendarPeriodListCurrentApi
    );
    yield put(
      overviewStaffToStaffHolidayCalendarPeriodListCurrentSuccess(response)
    );
  } catch (error) {
    yield put(overviewStaffToStaffHolidayCalendarPeriodListCurrentFail(error));
  }
}

export function* watchOverviewStaffToStaffHolidayCalendarPeriodListCurrent() {
  yield takeEvery(
    OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT,
    overviewStaffToStaffHolidayCalendarPeriodListCurrent
  );
}

//overviewStaffToStaffHolidayCalendarPeriodListFuture
function* overviewStaffToStaffHolidayCalendarPeriodListFuture() {
  try {
    const response = yield call(
      overviewStaffToStaffHolidayCalendarPeriodListFutureApi
    );
    yield put(
      overviewStaffToStaffHolidayCalendarPeriodListFutureSuccess(response)
    );
  } catch (error) {
    yield put(overviewStaffToStaffHolidayCalendarPeriodListFutureFail(error));
  }
}

export function* watchOverviewStaffToStaffHolidayCalendarPeriodListFuture() {
  yield takeEvery(
    OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE,
    overviewStaffToStaffHolidayCalendarPeriodListFuture
  );
}

//overviewStaffToStaffHolidayCalendarPeriodListPast
function* overviewStaffToStaffHolidayCalendarPeriodListPast() {
  try {
    const response = yield call(
      overviewStaffToStaffHolidayCalendarPeriodListPastApi
    );
    yield put(
      overviewStaffToStaffHolidayCalendarPeriodListPastSuccess(response)
    );
  } catch (error) {
    yield put(overviewStaffToStaffHolidayCalendarPeriodListPastFail(error));
  }
}

export function* watchOverviewStaffToStaffHolidayCalendarPeriodListPast() {
  yield takeEvery(
    OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST,
    overviewStaffToStaffHolidayCalendarPeriodListPast
  );
}

//overviewStaffToStaffHolidayCalendarPeriodList
function* overviewStaffToStaffHolidayCalendarPeriodList() {
  try {
    const response = yield call(
      overviewStaffToStaffHolidayCalendarPeriodListApi
    );
    yield put(overviewStaffToStaffHolidayCalendarPeriodListSuccess(response));
  } catch (error) {
    yield put(overviewStaffToStaffHolidayCalendarPeriodListFail(error));
  }
}

export function* watchOverviewStaffToStaffHolidayCalendarPeriodList() {
  yield takeEvery(
    OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST,
    overviewStaffToStaffHolidayCalendarPeriodList
  );
}

//staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembers
function* staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembers() {
  try {
    const response = yield call(
      staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembersApi
    );
    yield put(
      staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembersSuccess(
        response
      )
    );
  } catch (error) {
    yield put(
      staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembersFail(error)
    );
  }
}

export function* watchStaffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembers() {
  yield takeEvery(
    STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS,
    staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembers
  );
}

//staffToStaffHolidayCalendarPeriodSearch
function* staffToStaffHolidayCalendarPeriodSearch({ payload }) {
  try {
    const response = yield call(
      staffToStaffHolidayCalendarPeriodSearchApi,
      payload
    );
    yield put(staffToStaffHolidayCalendarPeriodSearchSuccess(response));
  } catch (error) {
    yield put(staffToStaffHolidayCalendarPeriodSearchFail(error));
  }
}

export function* watchStaffToStaffHolidayCalendarPeriodSearch() {
  yield takeEvery(
    STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH,
    staffToStaffHolidayCalendarPeriodSearch
  );
}

//staffLeaveRestrictionPeriodList
function* staffLeaveRestrictionPeriodList() {
  try {
    const response = yield call(getStaffLeaveRestrictionPeriodListApi);
    yield put(staffLeaveRestrictionPeriodListSuccess(response));
  } catch (error) {
    yield put(staffLeaveRestrictionPeriodListFail(error));
  }
}

export function* watchStaffLeaveRestrictionPeriodList() {
  yield takeEvery(
    STAFF_LEAVE_RESTRICTION_PERIOD_LIST,
    staffLeaveRestrictionPeriodList
  );
}

//staffLeaveRestrictionPeriodData
function* staffLeaveRestrictionPeriodData({ payload }) {
  try {
    const response = yield call(getStaffLeaveRestrictionPeriodDataApi, payload);
    yield put(staffLeaveRestrictionPeriodDataSuccess(response));
  } catch (error) {
    yield put(staffLeaveRestrictionPeriodDataFail(error));
  }
}

export function* watchStaffLeaveRestrictionPeriodData() {
  yield takeEvery(
    STAFF_LEAVE_RESTRICTION_PERIOD_DATA,
    staffLeaveRestrictionPeriodData
  );
}

//staffLeaveRestrictionPeriodCreate
function* staffLeaveRestrictionPeriodCreate({ payload }) {
  try {
    const response = yield call(createStaffLeaveRestrictionPeriodApi, payload);
    yield put(staffLeaveRestrictionPeriodCreateSuccess(response));
  } catch (error) {
    yield put(staffLeaveRestrictionPeriodCreateFail(error));
  }
}

export function* watchStaffLeaveRestrictionPeriodCreate() {
  yield takeEvery(
    STAFF_LEAVE_RESTRICTION_PERIOD_CREATE,
    staffLeaveRestrictionPeriodCreate
  );
}

//staffLeaveRestrictionPeriodUpdate
function* staffLeaveRestrictionPeriodUpdate({ payload }) {
  try {
    const response = yield call(updateStaffLeaveRestrictionPeriodApi, payload);
    yield put(staffLeaveRestrictionPeriodUpdateSuccess(response));
  } catch (error) {
    yield put(staffLeaveRestrictionPeriodUpdateFail(error));
  }
}

export function* watchStaffLeaveRestrictionPeriodUpdate() {
  yield takeEvery(
    STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE,
    staffLeaveRestrictionPeriodUpdate
  );
}

//staffLeaveRestrictionPeriodDelete
function* staffLeaveRestrictionPeriodDelete({ payload }) {
  try {
    const response = yield call(deleteStaffLeaveRestrictionPeriodApi, payload);
    yield put(staffLeaveRestrictionPeriodDeleteSuccess(response));
  } catch (error) {
    yield put(staffLeaveRestrictionPeriodDeleteFail(error));
  }
}

export function* watchStaffLeaveRestrictionPeriodDelete() {
  yield takeEvery(
    STAFF_LEAVE_RESTRICTION_PERIOD_DELETE,
    staffLeaveRestrictionPeriodDelete
  );
}

export default function* StaffLeave() {
  yield all([
    fork(watchStaffHolidayCalendarList),
    fork(watchStaffHolidayCalendarData),
    fork(watchStaffHolidayCalendarCreate),
    fork(watchStaffHolidayCalendarUpdate),
    fork(watchStaffHolidayCalendarDelete),
    fork(watchStaffHolidayCalendarGeneratePeriods),
    fork(watchStaffHolidayCalendarPeriodList),
    fork(watchStaffHolidayCalendarPeriodData),
    fork(watchStaffHolidayCalendarPeriodCreate),
    fork(watchStaffHolidayCalendarPeriodUpdate),
    fork(watchStaffHolidayCalendarPeriodDelete),
    fork(watchCalendarNonWorkingDayList),
    fork(watchCalendarNonWorkingDayData),
    fork(watchCalendarNonWorkingDayCreate),
    fork(watchCalendarNonWorkingDayUpdate),
    fork(watchCalendarNonWorkingDayDelete),
    fork(watchCreateStaffLeaveRequest),
    fork(watchStaffToStaffHolidayCalendarPeriodListCurrent),
    fork(watchStaffToStaffHolidayCalendarPeriodListFuture),
    fork(watchStaffToStaffHolidayCalendarPeriodListPast),
    fork(watchStaffToStaffHolidayCalendarPeriodList),
    fork(watchStaffLeaveDecisionApprove),
    fork(watchStaffLeaveDecisionDecline),
    fork(watchStaffToStaffHolidayCalendarPeriodListCurrentMyTeamMembers),
    fork(watchStaffToStaffHolidayCalendarPeriodListCurrentMy),
    fork(watchStaffLeaveDecisionData),
    fork(watchStaffLeaveDecisionListMyOpen),
    fork(watchStaffLeaveDecisionList),
    fork(watchOverviewStaffToStaffHolidayCalendarPeriodListCurrent),
    fork(watchOverviewStaffToStaffHolidayCalendarPeriodListFuture),
    fork(watchOverviewStaffToStaffHolidayCalendarPeriodListPast),
    fork(watchOverviewStaffToStaffHolidayCalendarPeriodList),
    fork(watchStaffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembers),
    fork(watchStaffToStaffHolidayCalendarPeriodSearch),
    fork(watchStaffLeaveRestrictionPeriodList),
    fork(watchStaffLeaveRestrictionPeriodData),
    fork(watchStaffLeaveRestrictionPeriodCreate),
    fork(watchStaffLeaveRestrictionPeriodUpdate),
    fork(watchStaffLeaveRestrictionPeriodDelete),
    fork(watchSeedApprovedStaffLeave),
  ]);
}

//seedApprovedStaffLeave - Task 24476
function* seedApprovedStaffLeave({ payload }) {
  try {
    const response = yield call(seedApprovedStaffLeaveApi, payload);
    // FetchAPI resolves to the parsed body, not an axios-style {data}.
    yield put(seedApprovedStaffLeaveSuccess(response));
  } catch (error) {
    yield put(seedApprovedStaffLeaveFail(error));
  }
}

export function* watchSeedApprovedStaffLeave() {
  yield takeEvery(SEED_APPROVED_STAFF_LEAVE, seedApprovedStaffLeave);
}
